import { Injectable } from '@angular/core';
import { DataService } from '../../../../../shared/services/data.service';
import { StorageService } from '../../../../../shared/services/storage.service';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Result } from '../../../../../shared/model/response.model';
import { URLS } from 'src/app/components/crm/crm-api-constants';
import { InsertSourcing } from '../../../../sales/requirements/popup/send-to-sourcing-popup/send-to-sourcing.model';
import { TableSourcingRequirementModel } from '../../../../../shared/components/ag-grid/ag-grid.model';
@Injectable({
  providedIn: 'root'
})
export class SourcingService {
  public sourcingId:string='';
  public sourcingNo:string='';
  onRowClicked = new BehaviorSubject<boolean>(false);
  private sourcingSelectedDataSubject = new BehaviorSubject<any>(undefined);
  public activeTab = new BehaviorSubject<any>(undefined);
  
  constructor(private service: DataService,  public storageService:StorageService) { }

  setSourcingSelectedData(data: any): void {
   this.sourcingSelectedDataSubject.next(data);
  }

  getSourcingSelectedData(): Observable<any> {
    return this.sourcingSelectedDataSubject.asObservable();
  }
  getSourcingRequirements(data: TableSourcingRequirementModel): Observable<any> {
    let url = 'app/sourcing/getSourcingRequirements';
    return this.service.post(url,data,true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
   }
  addSourcing(insertSourcingModel:InsertSourcing): Observable<Result> {
    let url = 'app/sourcing/createSourcing';
    return this.service.post(url, insertSourcingModel, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  removeRequirementsFromBatch(data: any): Observable<Result> {
    let url = 'app/sourcing/removeRequirementsFromBatch';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  addVendorsToBatch(data: any): Observable<Result> {
    let url = 'app/sourcing/addVendorsToBatch';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  toggleSourceApproval(data: any): Observable<Result> {
    let url = 'app/requirement/toggleSourceApproval';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  removeSourceApproval(data: any): Observable<Result> {
    let url = 'app/requirement/removeSourceApproval';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  clearPriority(data: {requirementId : string}): Observable<Result> {
    let url = 'app/requirement/clearPriority';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  priorityConfirmQuantity(data: any): Observable<Result> {
    let url = 'app/requirement/priorityConfirmQuantity';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getSourcingBatchStats(data: any): Observable<Result> {
    let url = 'app/sourcing/getSourcingBatchStats';
    return this.service.post(url, data, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getTabCountById(data: any): Observable<Result> {
    let url = "app/requirement/getTabCountByRequirementIdAndTabName";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  toggleIncludeInRfq(data: any): Observable<Result> {
    let url = "app/requirement/toggleIncludeInRfq";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getIncludedRfqVendors(data: any): Observable<Result> {
    let url = "app/sourcing/getIncludedRfqVendors";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  quickSourceRfq(data: any): Observable<Result> {
    let url = "app/sourcing/quickSourceRfq";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  sendRfq(data: any): Observable<Result> {
    let url = "app/sourcing/sendRfq";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  updateRfqVendor(data: any): Observable<Result> {
    let url = "app/requirement/updateRfqVendor";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getRfqResultDetails(data: any): Observable<Result> {
    let url = "app/sourcing/getRfqResultDetails";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
}
